module.exports = __webpack_public_path__ + "static/media/alimentos2.4264f140.png";